import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:59446/api';

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para adicionar token de autenticação
api.interceptors.request.use((config) => {
  const user = localStorage.getItem('user');
  if (user) {
    const userData = JSON.parse(user);
    if (userData.token) {
      config.headers.Authorization = `Bearer ${userData.token}`;
    }
  }

  // Se houver chave API, adicionar no header
  const apiKey = localStorage.getItem('apiKey');
  if (apiKey) {
    config.headers['x-api-key'] = apiKey;
  }

  return config;
});

// Interceptor para renovação deslizante do token e tratamento de erros
api.interceptors.response.use(
  (response) => {
    // Se o backend enviou um token renovado, atualizar no localStorage
    const newToken = response.headers['x-refresh-token'];
    if (newToken) {
      const stored = localStorage.getItem('user');
      if (stored) {
        const userData = JSON.parse(stored);
        userData.token = newToken;
        localStorage.setItem('user', JSON.stringify(userData));
      }
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
